import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01e7703e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "map" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_x text-lg" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "text-primary text-base font-bold mr-3" }
const _hoisted_7 = { class: "flex flex-column font-bold text-base" }
const _hoisted_8 = { class: "flex align-items-center gap-3" }
const _hoisted_9 = { class: "flex align-items-center gap-1 mt-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_car text-xl" }, null, -1))
const _hoisted_11 = { class: "flex align-items-center gap-1 mt-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_parking text-lg" }, null, -1))
const _hoisted_13 = { class: "flex align-items-center gap-1 mt-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_electricity_1 text-lg" }, null, -1))
const _hoisted_15 = { class: "flex gap-4 wp1200 absolute left-0 right-0 top-0 mt-3 pointer-events-none" }
const _hoisted_16 = { class: "relative flex align-items-center w-22rem pointer-events-auto" }
const _hoisted_17 = {
  key: 0,
  class: "icon-warpit_icon_search absolute right-0 mr-3"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_TE_bullet_list font-bold text-base" }, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "wp1200 py-4 px-4"
}
const _hoisted_20 = { class: "block text-2xl font-semibold mb-4" }
const _hoisted_21 = {
  key: 0,
  class: "no-scrollbar flex sm:flex-wrap gap-3 sm:gap-0 sm:-mt-2 sm:-ml-2 sm:-mr-2 overflow-x-scroll"
}
const _hoisted_22 = { class: "flex flex-column" }
const _hoisted_23 = { class: "flex gap-3" }
const _hoisted_24 = { class: "flex gap-1 align-items-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_car text-xl" }, null, -1))
const _hoisted_26 = { class: "flex gap-1 align-items-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_parking text-xl" }, null, -1))
const _hoisted_28 = { class: "flex gap-1 align-items-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_electricity_1 text-xl" }, null, -1))
const _hoisted_30 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Map = _resolveComponent("Map")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_NearbyCard = _resolveComponent("NearbyCard")!
  const _component_Information = _resolveComponent("Information")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Map, {
          markers: _ctx.markers,
          center: _ctx.center,
          zoom: _ctx.zoom,
          onCenterChanged: _ctx.updateCenter,
          onZoomChanged: _ctx.updateZoom,
          onSelectMarker: _ctx.selectMarker,
          markerInfoOnHover: false,
          "navigate-on-click": false
        }, {
          info: _withCtx(({ payload }) => [
            _createElementVNode("div", {
              class: "relative flex flex-column gap-2 p-2 w-15rem cursor-pointer",
              onClick: ($event: any) => (_ctx.selectStation(payload))
            }, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.unselectMarker && _ctx.unselectMarker(...args)), ["stop"])),
                class: "absolute right-0 top-0"
              }, _hoisted_5),
              _createElementVNode("span", _hoisted_6, _toDisplayString(payload.name), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", null, _toDisplayString(payload.all_cars), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", null, _toDisplayString(payload.free_parking_places), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", null, _toDisplayString(payload.chargers), 1)
                  ])
                ])
              ])
            ], 8, _hoisted_3)
          ]),
          _: 1
        }, 8, ["markers", "center", "zoom", "onCenterChanged", "onZoomChanged", "onSelectMarker"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_GMapAutocomplete, {
            class: "addressSearch",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.address = $event.target.value)),
            onPlace_changed: _ctx.setAddress,
            options: {
            componentRestrictions: { country: 'si' },
          },
            value: _ctx.address,
            placeholder: _ctx.$t('shared_mobility.search'),
            id: "address",
            maxlength: "255"
          }, null, 8, ["onPlace_changed", "value", "placeholder"]),
          (_ctx.address === null)
            ? (_openBlock(), _createElementBlock("i", _hoisted_17))
            : _createCommentVNode("", true),
          (_ctx.address !== null)
            ? (_openBlock(), _createElementBlock("i", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.address = null)),
                class: "icon-warpit_icon_x absolute right-0 mr-3 cursor-pointer"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Button, {
          class: "parkingRoundButton sm:hidden pointer-events-auto",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'SharedMobilityList' })))
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.selectedStation === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("shared_mobility.nearby")), 1),
          (_ctx.nearestStations && _ctx.nearestStations.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nearestStations, (station) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: station.id,
                    class: "grid sm:col-6 sm:mr-2 sm:mt-1"
                  }, [
                    _createVNode(_component_NearbyCard, {
                      class: "w-20rem sm:w-12",
                      item: station,
                      onSelected: _ctx.selectStation
                    }, {
                      spaces: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _createElementVNode("span", null, _toDisplayString(station.all_cars), 1)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("span", null, _toDisplayString(station.free_parking_places), 1)
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _hoisted_29,
                              _createElementVNode("span", null, _toDisplayString(station.chargers), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["item", "onSelected"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLoading && _ctx.nearestStations.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.$t("shared_mobility.no_stations")), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(_component_Information, {
          key: 1,
          station: _ctx.selectedStation,
          onBack: _ctx.unselectMarker
        }, null, 8, ["station", "onBack"]))
  ], 64))
}